import React, { Suspense, lazy } from "react";
import { Route, Redirect } from "react-router-dom";
import { LOGIN_PATH } from "../../Authentication/constants/NavigationConstants";
import { ACCESS_TOKEN } from "./tokenUtils";

const LoadingModal = lazy(() => import("../components/LoadingModal"));

function PrivateRoute({ component: Component, ...rest }) {
  let token = localStorage.getItem(ACCESS_TOKEN) || null;
  return (
    <Suspense fallback={<LoadingModal />}>
      <Route
        {...rest}
        render={props =>
          token ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: LOGIN_PATH,
                state: { from: props.location },
              }}
            />
          )
        }
      />
    </Suspense>
  );
}

export default PrivateRoute;
